/**
 * created by tianruojun
 * 发布设置配置项
 */
export const publishInformationConfig = {
    modules: ['mediaList']
};